<template>
  <div>
    <exercise-logic-id exCollection="personaExCollection" @ready="onReady" @error="onError" @saved="onSaved"
      @savedNext="onSavedNext" @loadedEx="onLoadedEx" :doc="doc" :eid="$route.params.eid" :shared="false">
      <template slot-scope="{ saveExercise }">
        <v-stepper v-model="e1">
          <v-stepper-header>
            <v-stepper-step color="amber" :complete="e1 > 1" step="1" @click="el = 1">Information</v-stepper-step>
            <v-divider></v-divider>

            <v-stepper-step color="amber" :complete="e1 > 2" step="1" @click="el = 1">Competency</v-stepper-step>
            <v-divider></v-divider>

            <v-stepper-step color="amber" :complete="e1 > 3" step="1" @click="el = 3">Goals</v-stepper-step>
            <v-divider></v-divider>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <v-row>
                <v-col cols="4" class="mb-4">
                  <h2 class="headline" v-text="$t('exercise_persona.step1.title')"></h2>
                </v-col>
                <v-col cols="8" lg="6" class="mb-4">
                  <p v-for="(item, index) in $t(
                    'exercise_persona.step1.description'
                  )" :key="index" v-text="item" />
                </v-col>
              </v-row>
              <v-row v-if="doc">
                <v-col cols="4">
                  <div cols="6" v-for="item in coreLeft" :key="`component-${item.model}`">
                    <component :is="item.component" v-model="doc[item.model]" :props="item.props" :disabled="!canSave" class="mb-3">
                    </component>
                  </div>
                </v-col>
                <v-col cols="8">
                  <div cols="6" v-for="item in coreRight" :key="`component-${item.model}`">
                    <component :is="item.component" v-model="doc[item.model]" :props="item.props" :disabled="!canSave" class="mb-3">
                    </component>
                  </div>
                </v-col>
              </v-row>
              <bottom-navigation :save="canSave" :next="true" :prev="false" :gridView="false" :gridToggle="false"
                @save="saveDoc(saveExercise, true)" @prev="prevStep" @next="canSave ? saveDoc(saveExercise, false) : nextStep()">
              </bottom-navigation>
            </v-stepper-content>
            <!-- Step 2 -->
            <v-stepper-content step="2">
              <v-row>
                <v-col cols="4" class="mb-4">
                  <h2 class="headline" v-text="$t('exercise_persona.step2.title')"></h2>
                </v-col>
                <v-col cols="8" lg="6" class="mb-4">
                  <p v-for="(item, index) in $t(
                    'exercise_persona.step2.description'
                  )" :key="index" v-text="item" />
                </v-col>
              </v-row>
              <v-row v-if="doc">
                <v-col cols="10" offset="1" v-for="item in competency" :key="`component-${item.model}`">
                  <component :is="item.component" v-model="doc[item.model]" :props="item.props" :disabled="!canSave" class="mb-3">
                  </component>
                </v-col>
              </v-row>
              <bottom-navigation :save="canSave" :next="true" :prev="true" :gridView="false" :gridToggle="false"
                @save="saveDoc(saveExercise, true)" @prev="prevStep" @next="canSave ? saveDoc(saveExercise, false) : nextStep()">
              </bottom-navigation>
            </v-stepper-content>

            <v-stepper-content step="3">
              <v-row>
                <v-col cols="4" class="mb-4">
                  <h2 class="headline" v-text="$t('exercise_persona.step3.title')"></h2>
                </v-col>
                <v-col cols="8" lg="6" class="mb-4">
                  <p v-for="(item, index) in $t(
                    'exercise_persona.step2.description'
                  )" :key="index" v-text="item" />
                </v-col>
              </v-row>
              <v-row v-if="doc">
                <v-col cols="6" v-for="item in goals" :key="`component-${item.model}`">
                  <component :is="item.component" v-model="doc[item.model]" :props="item.props" :disabled="!canSave" class="mb-3">
                  </component>
                </v-col>
              </v-row>
              <bottom-navigation :save="canSave" :next="true" :prev="true" :gridView="false" :gridToggle="false"
                @save="saveDoc(saveExercise, true)" @prev="prevStep" @next="canSave ? saveDoc(saveExercise, false) : nextStep()">
              </bottom-navigation>
            </v-stepper-content>

            <v-stepper-content step="4">
              <v-row>
                <v-col cols="4" class="mb-4">
                  <h2 class="headline" v-text="$t('exercise_persona.step3.title')"></h2>
                </v-col>
                <v-col cols="8" lg="6" class="mb-4">
                  <p v-for="(item, index) in $t(
                    'exercise_persona.step2.description'
                  )" :key="index" v-text="item" />
                </v-col>
              </v-row>
              <v-row v-if="doc">
                <v-col cols="12" v-for="item in end" :key="`component-${item.model}`">
                  <component :is="item.component" v-model="doc[item.model]" :props="item.props" :disabled="!canSave" class="mb-3">
                  </component>
                </v-col>
              </v-row>
              <bottom-navigation :save="canSave" :next="false" :prev="true" :gridView="false" :gridToggle="false"
                @save="saveDoc(saveExercise, true)" @prev="prevStep">
              </bottom-navigation>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </template>
    </exercise-logic-id>

    <v-dialog v-model="dialog" max-width="650">
      <v-card light>
        <v-card-title class="headline" v-text="$t('exercise_tov.saved.title')"></v-card-title>

        <v-card-actions>
          <v-btn color="white" top right absolute class="black--text" @click="dialog = false">
            Close
          </v-btn>

          <v-btn class="grey lighten-3" :to="`/users/project/${this.$route.params.id}`">
            Back to Project
          </v-btn>
          <v-btn class="amber" :to="`/users/project/${this.$route.params.id}/personas`">
            Back to List
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
import { BottomNavigation } from "@/components/core";
import { ExerciseLogicId } from "@/components/exercises";
import {
  UnitTag,
  UnitTextArea,
  UnitTextField,
  UnitDropdown,
  UnitRange,
  UnitImage,
} from "@/components/units";

const fb = require("@/firebaseConfig.js");

export default {
  name: "UserTov",
  data() {
    return {
      e1: 1,
      dialog: false,
      canSave: true,
      assignedUser: null,
      initialLoadDone: false,
      isMerging: false,
      dirtyFields: new Set(),
      remoteDoc: null,
      doc: {
        age: 24,
        gender: null,
        interests: [],
        sites: [],
        needs: [],
        frustrations: [],
        ourGoal: [],
        theirGoal: [],
      },
      coreLeft: [
        {
          label: "Persona",
          id: 1,
          component: UnitTextField,
          model: "persona",
          props: { title: "Persona" },
        },
        {
          label: "Name",
          id: 5,
          component: UnitTextField,
          model: "name",
          props: { title: "Name" },
        },
        {
          label: "Image",
          id: 5,
          component: UnitImage,
          model: "image",
          props: { title: "Image" },
        },
        {
          label: "Gender",
          id: 5,
          component: UnitDropdown,
          model: "gender",
          props: { items: ["Male", "Female", "Non Binary"], title: "Gender" },
        },
        {
          label: "Occupation",
          id: 2,
          component: UnitTextField,
          model: "occupation",
          props: { title: "Occupation" },
        },
        {
          label: "Location",
          id: 3,
          component: UnitTextField,
          model: "location",
          props: { title: "Location" },
        },
        {
          label: "Age",
          id: 4,
          component: UnitRange,
          model: "age",
          props: { min: 1, max: 99, title: "Age" },
        },
      ],
      coreRight: [
        {
          label: "Description",
          id: 2,
          component: UnitTextArea,
          model: "description",
          props: { title: "Description" },
        },
        {
          label: "Interests",
          id: 6,
          component: UnitTag,
          model: "interests",
          props: { title: "Interests" },
        },
        {
          label: "Related offers",
          id: 7,
          component: UnitTag,
          model: "sites",
          props: { title: "Related offers" },
        },
      ],
      competency: [
        {
          label: "Internet",
          id: 8,
          component: UnitRange,
          model: "internet",
          props: { min: 1, max: 5, title: "Internet" },
        },
        {
          label: "Social Media",
          id: 8,
          component: UnitRange,
          model: "social",
          props: { min: 1, max: 5, title: "Social Media" },
        },
        {
          label: "Messaging",
          id: 8,
          component: UnitRange,
          model: "messaging",
          props: { min: 1, max: 5, title: "Messaging" },
        },
        {
          label: "Games",
          id: 8,
          component: UnitRange,
          model: "games",
          props: { min: 1, max: 5, title: "Games" },
        },
        {
          label: "Apps",
          id: 8,
          component: UnitRange,
          model: "apps",
          props: { min: 1, max: 5, title: "Apps" },
        },
      ],
      goals: [
        {
          label: "What are their needs?",
          id: 9,
          component: UnitTag,
          model: "needs",
          props: { title: "What are their needs?" },
        },
        {
          label: "What are their goals?",
          id: 10,
          component: UnitTag,
          model: "theirGoal",
          props: { title: "What are their goals?" },
        },
        {
          label: "What are our goals?",
          id: 11,
          component: UnitTag,
          model: "ourGoal",
          props: { title: "What are our goals?" },
        },
        {
          label: "Would could be their frustrations?",
          id: 12,
          component: UnitTag,
          model: "frustrations",
          props: { title: "Would could be their frustrations?" },
        },
      ],
      end: [
        {
          label: "In an ideal world we would like...",
          id: 13,
          component: UnitTextArea,
          model: "ideal",
          props: { title: "In an ideal world we would like..." },
        },
      ],
      debug: false,
    };
  },
  components: {
    BottomNavigation,
    ExerciseLogicId,
    UnitTag,
    UnitTextArea,
    UnitTextField,
    UnitDropdown,
    UnitRange,
  },
  watch: {
    doc: {
      handler(newVal) {
        if (this.initialLoadDone && !this.isMerging) {
          Object.keys(newVal).forEach((key) => {
            this.dirtyFields.add(key);
          });
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
  },

  mounted() {
    this.checkPermission();
  },
  methods: {
    checkPermission() {
      const eid = this.$route.params.eid;
      if (!eid) return;
      Promise.all([
        fb.personaExCollection.doc(eid).get(),
        fb.profilesCollection.where("uid", "==", this.currentUser.uid).get(),
      ]).then(([personaDoc, profileSnapshot]) => {
        const isAdmin =
          !profileSnapshot.empty &&
          profileSnapshot.docs[0].data().webrole === "admin";
        if (personaDoc.exists && personaDoc.data().assignedUser) {
          this.assignedUser = personaDoc.data().assignedUser;
        }
        if (isAdmin) {
          this.canSave = true;
        } else if (personaDoc.exists && personaDoc.data().assignedUser) {
          this.canSave = personaDoc.data().assignedUser === this.currentUser.uid;
        }
      });
    },
    nextStep() {
      this.e1++;
    },
    prevStep() {
      this.e1--;
    },
    onReady() {},
    onError() {
      console.log("error");
    },
    onSaved(payload) {
      this.restoreAssignedUser(payload);
      this.dialog = true;
      console.log("on saved", this.dialog);
    },
    restoreAssignedUser(payload) {
      // saveExercise uses ref.set() which overwrites the whole document and
      // drops the top-level assignedUser field, so re-apply it after save.
      if (!this.assignedUser || !payload || !payload.id) return;
      fb.personaExCollection
        .doc(payload.id)
        .update({ assignedUser: this.assignedUser })
        .catch((error) => {
          console.log("Error restoring assignedUser", error);
        });
    },
    onLoadedRefs(refs) {
      console.log("loaded", refs);
    },
    onLoadedEx(ex) {
      console.log(ex);
      if (!ex || !ex.length) return;
      if (ex[0].assignedUser) {
        this.assignedUser = ex[0].assignedUser;
      }
      const remote = ex[0].doc;
      this.remoteDoc = JSON.parse(JSON.stringify(remote));
      if (!this.initialLoadDone) {
        this.doc = remote;
        this.$nextTick(() => {
          this.initialLoadDone = true;
        });
      } else {
        this.mergeRemoteChanges(remote);
      }
    },
    mergeRemoteChanges(remote) {
      this.isMerging = true;
      Object.entries(remote).forEach(([key, value]) => {
        if (!this.dirtyFields.has(key)) {
          this.$set(this.doc, key, value);
        }
      });
      this.$nextTick(() => {
        this.isMerging = false;
      });
    },
    saveDoc(saveExercise, notify) {
      this.isMerging = true;
      if (this.remoteDoc) {
        Object.entries(this.remoteDoc).forEach(([key, value]) => {
          if (!this.dirtyFields.has(key)) {
            this.$set(this.doc, key, value);
          }
        });
      }
      this.dirtyFields = new Set();
      this.$nextTick(() => {
        this.isMerging = false;
      });
      saveExercise(notify);
    },
    onSavedNext(payload) {
      this.restoreAssignedUser(payload);
      console.log("next step");
      this.nextStep();
    },
    mergeArrays(arr) {
      Object.entries(arr).forEach(([outerKey, value]) => {
        Object.entries(value).forEach(([key, value]) => {
          this.doc[outerKey][key] = value;
        });
      });
    },
  },
};
</script>

<style lang="scss"></style>
